import './StarIcon.scss';

export function StarIcon() {
  return (
    <svg className="star-icon" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24">
      <path d="M13.849 4.22c-.684-1.626-3.014-1.626-3.698 0L8.397 8.387l-4.552.361c-1.775.14-2.495 2.331-1.142 3.477l3.468 2.937-1.06 4.392c-.413 1.713 1.472 3.067 2.992 2.149L12 19.35l3.897 2.354c1.52.918 3.405-.436 2.992-2.15l-1.06-4.39 3.468-2.938c1.353-1.146.633-3.336-1.142-3.477l-4.552-.36-1.754-4.17Z" />
    </svg>
  );
}

export function HalfStarIcon() {
  return (
    <svg
      className="star-icon"
      aria-hidden="true"
      fill="none"
      viewBox="0 0 24 24">
      <path
        stroke="currentColor"
        strokeWidth="2"
        d="M 8.476,9.38 3.923,9.74 C 3.035,9.81 2.675,10.905 3.351,11.477 l 3.47,2.934 c 0.2844832,0.239178 0.4091843,0.618703 0.322,0.98 l -1.06,4.388 c -0.206,0.855 0.736,1.531 1.497,1.073 l 3.898,-2.351 c 0.32,-0.193 0.723,-0.193 1.044,0 l 3.898,2.351 c 0.76,0.458 1.703,-0.218 1.497,-1.073 l -1.06,-4.388 c -0.0867,-0.361277 0.03792,-0.74055 0.322,-0.98 l 3.47,-2.934 C 21.325,10.905 20.965,9.81 20.077,9.74 L 15.524,9.38 C 15.151198,9.3518394 14.82524,9.1180757 14.679,8.774 L 12.925,4.609 c -0.342,-0.812 -1.508,-0.812 -1.85,0 L 9.321,8.774 C 9.1747596,9.1180757 8.848802,9.3518394 8.476,9.38 Z"
      />
      <path
        stroke="currentColor"
        strokeWidth="2"
        fill="currentColor"
        d="M 8.5095678,9.4419191 3.956568,9.8019194 c -0.888,0.07 -1.248,1.1649996 -0.572,1.7369996 l 3.4699998,2.934 c 0.2844832,0.239178 0.4091843,0.618703 0.322,0.98 l -1.06,4.388 c -0.206,0.855 0.736,1.531 1.497,1.073 l 3.8980002,-2.351 c 0,-6.195436 0.205141,-15.0733248 -0.403,-13.8920002 L 9.3545678,8.8359191 c -0.1462404,0.3440757 -0.472198,0.5778394 -0.845,0.606 z"
      />
    </svg>
  );
}

export function HollowStarIcon() {
  return (
    <svg className="star-icon" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path stroke="currentColor" strokeWidth="2" d="M11.083 5.104c.35-.8 1.485-.8 1.834 0l1.752 4.022a1 1 0 0 0 .84.597l4.463.342c.9.069 1.255 1.2.556 1.771l-3.33 2.723a1 1 0 0 0-.337 1.016l1.03 4.119c.214.858-.71 1.552-1.474 1.106l-3.913-2.281a1 1 0 0 0-1.008 0L7.583 20.8c-.764.446-1.688-.248-1.474-1.106l1.03-4.119A1 1 0 0 0 6.8 14.56l-3.33-2.723c-.698-.571-.342-1.702.557-1.771l4.462-.342a1 1 0 0 0 .84-.597l1.753-4.022Z"/>
    </svg>
  );
}
